import { useEffect, useState } from 'react';

const readPersistedValue = (storageKey: string): string[] => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item): item is string => typeof item === 'string');
  } catch {
    return [];
  }
};

export const usePersistedStringArray = (
  storageKey: string,
  fallback: string[] = [],
): [string[], (next: string[]) => void] => {
  const [value, setValue] = useState<string[]>(() => {
    const persisted = readPersistedValue(storageKey);
    return persisted.length > 0 ? persisted : fallback;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      if (value.length === 0) {
        window.localStorage.removeItem(storageKey);
        return;
      }
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      // Ignore storage failures so filter state still works in-memory.
    }
  }, [storageKey, value]);

  return [value, setValue];
};
